import React from 'react';
import HeroImage from '../../../../images/features/saga/title.png';
import HeroBgImage from '../../../../images/features/saga/title_background.png';
import HeroBgSpImage from '../../../../images/features/saga/title_background_sp.png';
import { makeBackgroundImageStyles } from '../../../core/styles';
import { useHeroStyles } from '../../styles/hero';
import Typography from './StyledTypography';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import illustrationsSpImage from '../../../../images/features/saga/illustrations_sp.png';
import illustrationsLeftImage from '../../../../images/features/saga/illustrations_left.png';
import illustrationsRightImage from '../../../../images/features/saga/illustrations_right.png';
import SectionContainer from './SectionContainer';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    ...makeBackgroundImageStyles(HeroBgSpImage),
    backgroundSize: '98% 100%',
    [theme.breakpoints.up('sm')]: {
      ...makeBackgroundImageStyles(HeroBgImage),
      backgroundSize: '98% 100%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 0, 2.5),
    },
    display: 'flex',
    alignItems: 'center',
  },
  mainImg: {
    maxWidth: 220,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 400,
      width: '50%',
    },
  },
  box: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 5),
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  description: {
    '& p': {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.8,
    },
    width: '45%',
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: theme.spacing(2, 0, 0),
    },
  },
}));

const useOtherStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sideImg: {
    width: '22%',
    maxWidth: 300,
    position: 'absolute',
  },
  leftImg: {
    left: '5%',
  },
  rightImg: {
    right: '5%',
  },
  bottomImg: {
    width: '100%',
    maxWidth: 300,
    marginTop: theme.spacing(2),
  },
}));

const Hero = () => {
  const classes = useHeroStyles({ classes: useStyles(), imgMaxSize: 600 });
  const otherClasses = useOtherStyles();

  const description = (
    <>
      <div className={classes.description}>
        <Typography color="textPrimary">
          のんびりとした田園風景が広がる農業や水産業の盛んな佐賀県。
        </Typography>
        <Typography color="textPrimary">
          おてつたびを通じて、佐賀県の魅力を感じながら旅をしよう！
        </Typography>
      </div>
    </>
  );

  return (
    <SectionContainer>
      <div className={clsx(classes.root, otherClasses.root)}>
        <Hidden smDown>
          <img
            src={illustrationsLeftImage}
            className={clsx(otherClasses.sideImg, otherClasses.leftImg)}
            alt=""
          />
        </Hidden>
        <div className={clsx(classes.box, otherClasses.box)}>
          <h1 className={classes.main}>
            <img
              src={HeroImage}
              className={classes.mainImg}
              alt="おてつたび×佐賀県 - もっと「佐賀」が好きになる！"
            />
            <Hidden mdUp>
              <img
                className={otherClasses.bottomImg}
                src={illustrationsSpImage}
                alt=""
              />
            </Hidden>
          </h1>
          <Hidden smDown>{description}</Hidden>
        </div>
        <Hidden smDown>
          <img
            src={illustrationsRightImage}
            className={clsx(otherClasses.sideImg, otherClasses.rightImg)}
            alt=""
          />
        </Hidden>
      </div>
      <Hidden mdUp>{description}</Hidden>
    </SectionContainer>
  );
};

export default Hero;
